import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { IMAGE_DOMAIN } from 'config'
import BrandNav from 'components/BrandNav'
import './styles.css'

const askoBrochures = [
  {
    imageSrc: `${IMAGE_DOMAIN}asko/brochure/03.jpg`,
    name: '慎達公司產品總覽',
    link: `${IMAGE_DOMAIN}asko/brochure/03_24041901.pdf`,
    toc: [
      'Asko 雅士高家電',
      'Vinvautz 法國名望酒櫃',
      'Gorenje 獨立復古冰箱',
    ]
  },
  // {
  //   imageSrc: `${IMAGE_DOMAIN}asko/brochure/01.jpg`,
  //   name: '瑞典雅士高廚房蒸烤系列',
  //   link: `${IMAGE_DOMAIN}asko/brochure/01.pdf`,
  //   toc: []
  // },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/brochure/02.jpg`,
    name: '瑞典雅士高廚房',
    link: `${IMAGE_DOMAIN}asko/brochure/02_24041601.pdf`,
    toc: [
      'DFS233IB.W/S',
      'DFS244IB.S',
      'DBI233IB.W / S',
      'DBI654IB.W / S',
      'DFI433B',
      'DFI654B',
    ]
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/brochure/04.jpg`,
    name: '瑞典雅士高洗衣房',
    link: `${IMAGE_DOMAIN}asko/brochure/04_24041901.pdf`,
    toc: [
      'W4114C.W.TW',
      'W4086C.W.TW',
      'W2084C.W.TW',
      'T411HD',
      'T208C.W',
    ]
  },
]

class Brochure extends Component {
  // static propTypes = {
  //   position: PropTypes.oneOf(['fixed', 'absolue', 'sticky'])
  // }

  componentDidMount() {
    document.title = '型錄'
    window.scrollTo(0, 0)
  }

  render = () => {
    const brandId = this.props.match.params.brand
    let brochures
    switch (brandId) {
      case 'asko':
        brochures = askoBrochures
        break
      default:
        brochures = []
    }

    return (
      <div style={{ marginTop: '65px' }}>
        <BrandNav brand={brandId} />
        <div className="brochure-container" style={{ marginTop: '30px', marginBottom: '30px' }}>
          {brochures.map(item => this.renderBrochure(item))}
        </div>
      </div>
    )
  }

  renderBrochure = (item) => (
    <div key={item.name} className="brochure-card">
      <a className="brochure-card__image" href={item.link} target="_blank">
        <img alt={item.name} src={item.imageSrc} />
      </a>
      <div className="brochure-card__summary">
        <h4>
          <a href={item.link} target="_blank">{item.name}</a>
        </h4>
        <ul>
          {item.toc.map(tocItem => (<li key={tocItem}>{tocItem}</li>))}
        </ul>
      </div>
    </div>
  )
}

export default withRouter(Brochure)



// WEBPACK FOOTER //
// ./src/containers/Brochure/index.js